<template>
  <v-col
    cols="12" md="4" lg="4" xl="4"
    class="pl-5"
  >

    <v-row align="center" class="mb-3">
      <v-checkbox dense hide-details v-model="innerVal" class="mt-0 examination-label" :label="label"></v-checkbox>
    </v-row>

    <hr v-show="innerVal" class="mt-5">
    <v-row v-show="innerVal">
      <slot name="sub"></slot>
    </v-row>
  </v-col>
</template>

<script>
  export default {
    name: 'FormExaminationItem',

    props: {
      value: { type:Boolean, default:false },
      label: { type: String , default:'' }
    },

    data() { 
      return {
        innerVal: this.value
      }
    },

    watch: {
      value(val) {
        this.innerVal = val
      },
      innerVal(val) {
        this.$emit('input', val)
      }
    },
  }
</script>

<style lang="scss" scoped>
  .examination-label.v-input--checkbox::v-deep {
    .v-label, .v-icon {
      font-size: 14px;
    }
  }
</style>